module.exports = __webpack_public_path__ + "static/img/cicl_logo.a794802a.png";